import { Box, Grid, Typography } from "@mui/material";
import { ReactElement } from "react";
import { customStyles } from "./index.styles";

export interface FeatureItem {
  icon: ReactElement;
  text: string;
}

interface FeatureCardsProps {
  features: FeatureItem[];
  textColor?: string;
}

const FeatureCards = ({ features, textColor }: FeatureCardsProps) => {
  return (
    <Box width="100%" display="flex" justifyContent="center" py={2}>
      <Grid container spacing={1} justifyContent="center">
        {features.map((feature, index) => (
          <Grid
            xs={6}
            md={3}
            item
            key={index}
            sx={customStyles.iconGrid}
          >
            <Box sx={customStyles.iconBox}>
              {feature.icon}
              <Typography
                sx={{
                  ...customStyles.iconText,
                  color: textColor || customStyles.iconText.color,
                }}
              >
                {feature.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default FeatureCards;
